import React, { useEffect } from 'react';
import './css/App.css';
import './css/OrstedSans.css';
import { useDispatch, useSelector } from 'react-redux';
import Menu from './components/Menu';
import SafetyInduction from './components/safetyinduction/SafetyInduction';
import { setPlaying, clearChapterActionsThunk, toggleInfoPopupThunk, changeStoryAction, toggleWeatherThunk } from './store/StoryStore';


const Home = () => {
    const dispatch = useDispatch();
    const storyState = useSelector(state => state.storyState);

    useEffect(() => {
        dispatch(setPlaying(false));
        dispatch(clearChapterActionsThunk());
        dispatch(toggleInfoPopupThunk(undefined, false));
        dispatch(toggleWeatherThunk(false));

        setTimeout(() => {
            if (
                storyState.stories &&
                storyState.stories.length > 0 &&
                storyState.stories[0].chapters.length !== 0
            ) {
                const defaultStory = storyState.stories.find(s => s.cultureCode === 'da-DK' && s.category === 'Sikkerhedsintroduktion' && !(s.name || '').includes('kopi'));
                if (defaultStory && defaultStory.id) {
                    dispatch(changeStoryAction({ storyId: defaultStory.id }));
                }
            }
        }, 0);
    }, []);


    return (
        <div className="App">
            <Menu />
            <SafetyInduction 
                isSafetyInduction={true}
                isShortSafetyInduction={false}
                languageButtonIsVisible={true}
            />
        </div>
    );
};

export default Home;